export default __webpack_public_path__ + "static/media/sql.0c704628.jpg";